import { core } from '@/api/api-endpoints'

export default {
  data() {
    return {
      markerPopup: {},
      head: null,
      rows: {},
      fields: {},
      loading: true,
      statuses: [],
      statusClass: '',
    }
  },
  created() {
    this.getStatusCollectionEndpoint()
  },
  destroyed() {
    if (this.destroySubs) {
      this.destroySubs.unsubscribe()
    }
  },
  methods: {
    registerVueInMap() {
      this.destroySubs = this.$emitter.listen('geo.destroyMap', () => {
        this.$destroy()
      })
    },
    fetchGeoObjectPopupData(endpoint) {
      this.loading = true
      this.$sharedServices.store
        .dispatch('updateUrlEndpoint', {
          endpoint: endpoint,
        })
        .then((r) => {
          this.rows = Object.assign({}, r.data.fields)
          this.head = r.data.head
          this.fields = r.data.model
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    async getStatusCollectionEndpoint() {
      const obj = {
        garbage: 'tko_object',
        places: 'msn',
      }
      this.statuses = await (
        await this.$sharedServices.store.dispatch('updateUrlEndpoint', {
          endpoint: core.collection('status', {
            query: { type: obj[this.iconType] },
          }),
          fromCache: true,
        })
      ).data.status
      this.setStatusClass()
    },
    setStatusClass() {
      let status = ' inactive'
      if (this.fields.hasOwnProperty('status_code')) {
        status = ` ${this.fields.status_code}`
      }

      this.statusClass = status
    },
  },
}
